export default {
  Tabs: {
    parts: ['root', 'tablist', 'tab', 'tabpanels', 'tabpanel', 'indicator'],
    baseStyle: {},
    sizes: {},
    variants: {
      secondary: {
        tab: {
          borderRadius: 1.5,
          paddingY: 1.75,
          paddingX: 4.5,
          _selected: { bgColor: 'text.base', color: '#FFFFFF' },
        },
        tabpanel: {
          padding: 0,
        },
      },
    },
    defaultProps: {
      variant: 'primary',
    },
  },
};
